<template>
  <el-container>
    <el-header style="display: flex; align-items: center; justify-content: space-between">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>网站参数设置</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button-group>
        <el-button type="info" icon="el-icon-eleme" @click.native="formSubmit('refForm')">保存</el-button>
      </el-button-group>
    </el-header>
    <el-main>
      <el-divider content-position="left">
        <font color="red">网站信息</font>
      </el-divider>
      <el-form :model="SystemParameters" :rules="rules" ref="refForm" status-icon label-width="150px">
        <el-form-item label="系统全称" prop="systemName">
          <el-input v-model="SystemParameters.systemName" placeholder="请输入系统全称">
          </el-input>
        </el-form-item>
        <el-form-item label="系统简称" prop="systemMiniName">
          <el-input v-model="SystemParameters.systemMiniName" placeholder="请输入系统简称"></el-input>
        </el-form-item>
        <el-form-item label="部门全称" prop="maintenanceUnitName">
          <el-input v-model="SystemParameters.maintenanceUnitName" placeholder="请输入部门全称">
          </el-input>
        </el-form-item>
        <el-form-item label="部门简称" prop="maintenanceUnitMiniName">
          <el-input v-model="SystemParameters.maintenanceUnitMiniName" placeholder="请输入部门简称"></el-input>
        </el-form-item>
        <el-divider content-position="left">
          <font color="red">网站联系人信息</font>
        </el-divider>
        <el-form-item label="网站联系人姓名" prop="userName">
          <el-input v-model="SystemParameters.userName" placeholder="请输入联系人姓名" />
        </el-form-item>
        <el-form-item label="联系人手机号码" prop="phone">
          <el-input v-model="SystemParameters.phone" placeholder="请输入联系人手机号" />
        </el-form-item>
        <el-form-item label="网站联系人邮箱" prop="email">
          <el-input v-model="SystemParameters.email" placeholder="请输入联系人邮箱" />
        </el-form-item>
        <el-divider content-position="left">
          <font color="red">工单办理期限</font>
        </el-divider>
        <el-form-item label="期限值(小时)" prop="transferHours">
          <el-input v-model="SystemParameters.transferHours" placeholder="请输入办理期限小时数"></el-input>
        </el-form-item>
        <el-divider content-position="left">
          <font color="red">工单所属领域设置</font>
        </el-divider>
        <el-form-item label="领域设置">
          <el-tag :key="tag" v-for="tag in SystemParameters.domains" closable :disable-transitions="false"
            @close="handleClose(tag)">
            {{ tag }}
          </el-tag>
          <el-input class="input-new-tag" v-if="domain.inputVisible" v-model="domain.inputValue" ref="saveTagInput"
            size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm" />
          <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 添加领域</el-button>
        </el-form-item>
      </el-form>

      <!--  -->
    </el-main>
  </el-container>
</template>

<script>
export default {
  created() {
    this.pstApi.setWindowTitle("网站参数设置");
    //读取系统参数
    this.getWebsiteParameter();
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (value == "") {
        return callback(new Error("手机号不能为空"));
      }

      setTimeout(() => {
        var isPhone =
          /^(13[0-9]|14[5-9]|15[0-3,5-9]|16[2,5,6,7]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/.test(
            value
          );
        if (!isPhone) {
          callback(new Error("请输入手机号码"));
        }
        callback();
      }, 1000);
    };
    var checkEmail = (rule, value, callback) => {
      if (value == "") {
        callback();
      }

      setTimeout(() => {
        var isEMail =
          /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(
            value
          );
        if (!isEMail) {
          callback(new Error("请输入正确的邮箱"));
        }
        callback();
      }, 1000);
    };
    var checkHours = (rules, value, callback) => {
      var reg = /^\+?[1-9][0-9]*$/;
      if (!reg.test(value)) {
        callback(new Error("整数格式错误"));
      } else {
        //console.log("检测通过");
        callback();
      }
    };
    return {
      //领域
      domain: {
        //tags: [],
        inputVisible: false,
        inputValue: "",
      },

      //网站参数
      SystemParameters: {
        systemName: "",
        systemMiniName: "",
        maintenanceUnitName: "",
        maintenanceUnitMiniName: "",
        userName: "",
        phone: "",
        email: "",
        transferHours: 0,
        domains: "",
      },
      //参数校验
      rules: {
        systemName: [
          { required: true, message: "请输入系统全称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        systemMiniName: [
          { required: true, message: "请输入系统简称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        maintenanceUnitName: [
          { required: true, message: "请输入部门全称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        maintenanceUnitMiniName: [
          { required: true, message: "请输入部门简称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        userName: [
          { required: true, message: "请输入网站联系人姓名", trigger: "blur" },
          {
            min: 2,
            max: 10,
            message: "长度在 2 到 10 个字符",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: true,
            trigger: "blur",
            validator: checkPhone,
          },
        ],
        email: [
          {
            trigger: "blur",
            validator: checkEmail,
          },
        ],
        transferHours: [
          {
            required: true,
            trigger: "blur",
            validator: checkHours,
          },
        ],
      },
    };
  },
  methods: {
    //向服务器读取系统参数
    getWebsiteParameter() {
      //console.log('get website')
      this.pstApi
        .getWebsiteAllParameters()
        .then((resp) => {
          //读取成功
          var data = resp.data;
          //console.log(data)
          this.SystemParameters.systemName = data.systemName;
          this.SystemParameters.systemMiniName = data.systemMiniName;
          this.SystemParameters.maintenanceUnitName = data.maintenanceUnitName;
          this.SystemParameters.maintenanceUnitMiniName =
            data.maintenanceUnitMiniName;
          this.SystemParameters.transferHours = data.transferHours;
          this.SystemParameters.domains = data.domains;
          this.SystemParameters.userName = data.userName;
          this.SystemParameters.phone = data.phone;
          this.SystemParameters.email = data.email;

        })
        .catch((error) => {
          var message = error.response.data.Message;
          if (message == null) {
            message = "服务器访问失败";
          }
          this.$toast(message);
        });
    },
    //表单提交
    formSubmit(formName) {
      //校验
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          // console.log("error submit!!");
          this.$toast("数据校验错误");
          return false;
        } else {
          //校验通过
          var systemName = this.SystemParameters.systemName;
          var systemMiniName = this.SystemParameters.systemMiniName;
          var maintenanceUnitName = this.SystemParameters.maintenanceUnitName;
          var maintenanceUnitMiniName =
            this.SystemParameters.maintenanceUnitMiniName;
          var transferHours = parseInt(this.SystemParameters.transferHours);
          let domains = this.SystemParameters.domains;
          let userName = this.SystemParameters.userName;
          let phone = this.SystemParameters.phone;
          let email = this.SystemParameters.email;

          //向服务器put数据
          this.pstApi
            .updateWebiteParameters(
              systemName,
              systemMiniName,
              maintenanceUnitName,
              maintenanceUnitMiniName,
              transferHours,
              domains,
              userName,
              phone,
              email
            )
            .then(() => {
              //修改成功
              this.$toast("修改成功");
              this.pstApi.setWebsiteParameters(this.SystemParameters);
            })
            .catch((err) => {
              var message = err.response.data.Message;
              if (message == null) {
                message = "服务器访问失败";
              }
              this.$toast(message);
            });
        }
      });
    },
    //========================================
    handleClose(tag) {
      this.SystemParameters.domains.splice(this.SystemParameters.domains.indexOf(tag), 1);
    },

    showInput() {
      this.domain.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.domain.inputValue;
      if (inputValue) {
        //this.$toast(inputValue);
        this.SystemParameters.domains.push(inputValue);
      }
      //console.log(this.SystemParameters.domains)
      this.domain.inputVisible = false;
      this.domain.inputValue = "";
    },
  },
};
</script>

<style lang="less" scoped>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 40px;
}

//工具栏样式
.cust_seach {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  padding: auto 5px;

  .btnLeft {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
  }

  .btnTitle {
    flex: 2;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }

  .btnStatus {
    flex: 1;
    margin: 0;

    /deep/ .el-input__inner {
      height: 41px;
      border-radius: 0px;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }

  .el-button-group>.el-button:first-child:last-child {
    border-radius: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.el-select {
  float: left;
}

.cust_pagin {
  display: flex;
  position: sticky;
  bottom: 0;
  z-index: 999;
}

/deep/.el-breadcrumb__separator {
  color: rgb(87, 86, 86);
}

/deep/.el-input.is- .el-input__inner {
  color: #031944;
}

/deep/.el-textarea.is- .el-textarea__inner {
  color: #031944;
}

.headtool {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.miniTool {
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

//
.img-list {
  overflow: hidden;
  width: 100%;

  // 文件列表
  .img-li-box {
    float: left;
    text-align: left;
    position: relative;
    display: block; //Inline-block
    width: 200px;
    height: 270px;
    padding: 5px;
    margin: 5px 20px 20px 0;
    border: 1px solid #d1dbe5;
    border-radius: 4px;
    transition: all 0.3s;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);

    // 图片
    .img-li-b--url {
      display: block;
      width: 100%;
      height: 190px;
      margin: 0 auto;
      border-radius: 4px;
    }

    // 底部
    .img-li-b--bottom {
      margin-top: 10px;

      // 名称
      .img-li-b--name {
        width: 90%;
        text-overflow: ellipsis;
        overflow: hidden;
        height: 25px;
        line-height: 25px;
      }
    }

    // 删除按钮
    .img-li-b--delete {
      position: absolute;
      bottom: 10px;
      right: 10px;
      color: #8492a6;
      cursor: pointer;
      font-size: 1.1em;
    }

    // 放大遮罩层
    .img-li-b--layer {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      height: 200px;
      color: #fff;
      text-align: center;
      z-index: 5;
      background-color: rgba(0, 0, 0, 0.4);

      // 放大按钮
      i {
        font-size: 1.6em;
        margin-top: 80px;
      }
    }

    .img-li-b--delete,
    .img-li-b--layer {
      opacity: 0;
      transition: all 0.3s;
    }

    // 悬浮可见删除 or 放大按钮
    &:hover {

      .img-li-b--delete,
      .img-li-b--layer {
        opacity: 1;
      }
    }

    // 上传进度
    &.img-li-b--progress {
      // padding: 0;
      // text-align: center;
      // padding-top: 0px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  // 上传按钮
  .img-li-b--upload {
    float: left;
    width: 200px;
    height: 270px;
    display: table;
    text-align: center;

    .img-li-b--upl--field {
      width: 100%;
      display: table-cell;
      vertical-align: middle;
    }
  }
}

.el-dialog-div {
  margin: 0 auto;
  height: 500px;
  overflow: auto;
  display: flex;
  align-items: center;
}

/deep/ .el-drawer__body {
  overflow-y: none;
  padding: 5px 5px;
  margin-bottom: 50px;
}

.demo-drawer__footer {
  width: 100%;

  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: center;
  background-color: white;

  .el-button {
    flex: 1;
  }
}

//
.el-tag+.el-tag {
  margin-left: 10px;
}

.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>